import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HelperService } from '../../services/helper.service';
import { ShippingService } from '../../services/api-services/shipping.service';

@Component({
  selector: 'app-view-rx-detail',
  templateUrl: './view-rx-detail.component.html',
  styleUrl: './view-rx-detail.component.scss'
})
export class ViewRxDetailComponent {
  progress_spinner = false;
  drugList: any[] = [];
  drugListFound = false;

  constructor(public dialogRef: MatDialogRef<ViewRxDetailComponent>,
    public helperService: HelperService,
    private shippingService: ShippingService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any) {
  }

  ngOnInit(): void {
    this.getDrugList();
  }

  //  Fetch the drug list based on refill_request_order_id
  private getDrugList(): void {
    this.progress_spinner = true;
    const payload = {
      refill_request_order_id: this.props?.item?.rowId
    };
    if (!payload.refill_request_order_id) {
      console.error('Missing rowId for refill request order.');
      this.drugListFound = false;
      this.progress_spinner = false;
      return;
    }
    this.shippingService.refill_get_drug_list(payload).subscribe({
      next: (res: any) => {
        this.progress_spinner = false;
        if (res?.body?.success) {
          this.drugList = res.body.data?.medication_detail || [];
          this.drugListFound = this.drugList.length > 0;
        } else {
          this.drugListFound = false;
          this.progress_spinner = false;
        }
      },
      error: (err) => {
        console.error('Error fetching drug list:', err);
        this.progress_spinner = false;
        this.dialogRef.close(false);
      }
    });
  }

  print() {
    window.print();
  }
}
